module.exports = __webpack_public_path__ + "img/save-outline-violet.5952f098.svg";